import React, { Fragment } from 'react'
import { useCallback } from 'sb-hooks'

import Field from 'components/_new/forms/Field/Field'
import FieldState from 'components/_new/forms/FieldState/FieldState'
import EmailSuggestion from 'components/auth/EmailSuggestion/EmailSuggestion'

import messages from './messages'


const EmailField = ({ className, field, standardView, loading, onBlur, onChange }) => {
  const handleEmailUpdate = useCallback((value) => {
    field.set(value)
  }, [ field ])

  const fieldProps = {
    [standardView ? 'placeholder' : 'label']: messages.label,
    standardView,
  }

  return (
    <Fragment>
      <Field
        className={className}
        id="emailRegister"
        field={field}
        type="email"
        onBlur={onBlur}
        loading={loading}
        onChange={onChange}
        autoComplete="email"
        {...fieldProps}
      />
      <FieldState field={field}>
        {
          ({ value }) => (
            <EmailSuggestion
              email={value}
              onConfirm={handleEmailUpdate}
            />
          )
        }
      </FieldState>
    </Fragment>
  )
}


export default EmailField
